// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"1":"3dbf00fb","52":"616c4d75","164":"05358f09","728":"36534fe3","750":"76b2dfff","821":"4f7d9849","929":"e44ff5f7","966":"411eabe9"}[chunkId] + ".js";
};